<template>
  <div class="driver-item-container">
    <div
      v-if="driver.root == 1"
      class="driver-item"
      @click.stop="driverItem(driver)"
    >
      <div v-if="driver.teamId">
        <common-ellipsis-tooltip
          effect="dark"
          :content="driver.primaryDriverName || '--'"
          placement="top"
        ></common-ellipsis-tooltip>
        <common-ellipsis-tooltip
          effect="dark"
          :content="driver.secondlyDriverName || '--'"
          placement="top"
        ></common-ellipsis-tooltip>
      </div>
      <div v-else>
        <!-- <fl-avatar
          :src="driver.avatar"
          :nickname="driver.name"
          :size="26"
          style="
          vertical-align: middle;
          margin-right: 8px;
          border: 1px solid #dee5ef;
        "
        ></fl-avatar> -->
        <common-ellipsis-tooltip
          effect="dark"
          :content="driver.name || '--'"
          placement="top"
        ></common-ellipsis-tooltip>
      </div>
    </div>
    <div
      v-if="driver.root == 2"
      class="driver-item2"
      @click.stop="driverItem2(driver)"
    >
      <!-- <img src="../../images/Add.svg" alt="" class="avatar" /> -->
      <el-tooltip
        class="item"
        effect="dark"
        content="No Permission"
        placement="top"
        :disabled="!driver.noPermission"
      >
        <span :class="['name', driver.noPermission ? 'is-disabled' : '']">{{
          driver.name
        }}</span>
      </el-tooltip>
    </div>
    <div v-if="driver.root == 3" class="driver-item driver-item3">
      <div
        v-if="driver.docType === 'img'"
        @click.stop="vieweImg(driver.avatar)"
      >
        <viewer :options="options" style="display: inline-block">
          <el-image
            :src="fixImageUrlToPreview(driver.avatar)"
            lazy
            style="
              width: 26px;
              height: 26px;
              vertical-align: middle;
              margin-right: 8px;
            "
          >
            <div slot="error" class="image-slot">
              <img src="../../images/ic-photo.svg" alt="" class="avatar" />
            </div>
          </el-image>
        </viewer>
        <span class="name" style="cursor: pointer">{{ driver.name }}</span>
      </div>
      <template v-if="driver.docType === 'pdf'">
        <div
          v-if="driver.clickAll"
          @click.stop="pdfPreView(driver)"
          style="cursor: pointer"
        >
          <img src="../../images/ic-file-doc.svg" alt="" class="avatar" />
          <span class="name" style="cursor: pointer">{{ driver.name }}</span>
        </div>
        <div v-else @click.stop="pdfPreView(driver)" style="cursor: pointer">
          <img src="../../images/ic-file-doc.svg" alt="" class="avatar" />
          <span class="name" style="cursor: pointer">{{ driver.name }}</span>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { api as viewerApi } from "v-viewer";
export default {
  name: "",
  components: {},
  props: {
    driver: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      options: {
        inline: true,
        toolbar: false, // 是否显示工具栏
        navbar: false, // 是否显示缩略图底部导航栏
        title: false,
      },
    };
  },
  computed: {},
  methods: {
    // driverItem
    driverItem(item) {
      // console.log("driverItem", JSON.stringify(item));
      this.$emit("driverItem", item);
    },
    // driverItem2
    driverItem2(item) {
      // console.log("driverItem2", JSON.stringify(item));
      if(item.noPermission) return;
      this.$emit("driverItem2", item);
    },
    // imgPreView
    imgPreView(item) {
      // console.log("imgPreView", JSON.stringify(item));
      this.$emit("imgPreView", item);
    },
    // pdfPreView
    pdfPreView(item) {
      // console.log("pdfPreView", JSON.stringify(item));
      this.$emit("pdfPreView", item);
    },
    // vieweImg
    vieweImg(url) {
      if (this.$route.name == "document") {
        this.$buriedPoints(4.11);
      }
      if (!url) return;
      let editUrl = url
        .replace(/^http[s]*:\/\/[^/]+/, "")
        .replace(/(\.\w+)$/, "_h800$1");
      viewerApi({
        options: this.options,
        images: [editUrl],
      });
    },
    fixImageUrlToPreview(url) {
      return url
        .replace(/^http[s]*:\/\/[^/]+/, "")
        .replace(/(\.\w+)$/, "_h26$1");
    },
  },
};
</script>

<style lang="scss" scoped>
.driver-item-container {
  max-width: 100%;
  // display: flex;
  // align-items: center;
  .driver-item {
    // cursor: pointer;
    .avatar {
      width: 26px;
      height: 26px;
      border-radius: 100%;
      vertical-align: middle;
      margin-right: 8px;
    }
    .name {
      color: #000;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: inline-block;
      // width: calc(100% - 32px);
      vertical-align: middle;
      font-weight: 600;
      font-size: 12px;
      font-weight: 600;
      color: #000000;
    }
    .name2 {
      display: block;
      width: calc(100%);
    }
    /deep/.fl-avatar {
      color: #fff;
    }
  }
  .driver-item3 {
    cursor: auto;
    .avatar {
      border-radius: 2px !important;
      cursor: pointer;
    }
    .img {
      border: 1px solid #dee5ef;
    }

    .driver-img {
      /deep/ {
        img {
          border: 1px solid #dee5ef;
          border-radius: 2px;
        }
        .avatar {
          border: 0 none;
        }
      }
    }
  }
  .driver-item2 {
    cursor: pointer;
    .avatar {
      vertical-align: middle;
      margin-right: 8px;
    }
    .name {
      color: #4066d4 !important;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: inline-block;
      // width: calc(100% - 32px);
      vertical-align: middle;
      font-weight: 600;
      font-size: 12px;
      font-weight: 600;
      color: #000000;
    }
    .is-disabled {
      color: #dadce1 !important;
    }
  }
}
</style>
